export default __webpack_public_path__ + "static/banner-managing-the-christmas-budget-a64b8f22c2b2fb9504b494c098677d8e.jpg";